import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeLetterheadCreate,
  detail: routeLetterheadDetail,
  home: routeLetterheadHome,
  root: routeLetterheadRoot,
} = createDoctypeRoutes({
  createName: 'new-letterhead',
  createPath: 'new-letterhead',
  detailName: 'letterheadDetail',
  doctype: DOCTYPES.LETTER_HEAD,
  homeName: 'letterhead-home',
  path: 'letterhead',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/letterhead/AddLetterhead.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/letterhead/ViewLetterhead.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/letterhead/LetterheadView.vue'),
  },
})

export { routeLetterheadCreate, routeLetterheadDetail, routeLetterheadHome, routeLetterheadRoot }
